import React from 'react'
import { LoginContext } from '../UserContext'
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
function Header() {
      const { user, login, logout,products } = React.useContext(LoginContext);
    const navigate = useNavigate();
       function userLogout() {
   window.location.href='/'
  }
  return (
    <div
          className="Login_Header"
          style={{
            background: "#2874f0",
            paddingInline: 30,
            paddingBlock: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
       
          <h4
          
            style={{
              fontSize: "2.3em",
              color: "white",
              marginBlock: "0.5em",
            }}
          >
            Ekart 🛍️
          </h4>

        
<div style={{display:'flex',alignItems:'center'  }}>
 <p    onClick={()=>{navigate('/cart/false')} } style={{marginRight:15,  color: "white",
              fontWeight: 700,fontSize:20}}>{user.name}'s Cart 🛒 </p>
          <p
            style={{
              color: "white",
              fontWeight: 700,
            }}
            onClick={userLogout}
          >
            LOGOUT
          </p>
          </div>
        </div>
  )
}

export default Header